export const defaultEN = {
  404: {
    main: 'Oops! The requested page was not found.',
    back: 'Back to top'
  }
}
